/*
 * QQQ - Low-code Application Framework for Engineers.
 * Copyright (C) 2021-2026.  Kingsrook, LLC
 * 651 N Broad St Ste 205 # 6917 | Middletown DE 19709 | United States
 * contact@kingsrook.com
 * https://github.com/Kingsrook/
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

import {GridRowId} from "@mui/x-data-grid-pro";
import {createContext} from "react";


/*******************************************************************************
 ** Which grid rows a user has expanded (e.g. to show a multi-line cell one entry
 ** per line), and how a cell asks to toggle its row.  The query screen provides
 ** it around its grid and lets expanded rows grow; the default is inert, so a
 ** cell rendered without a provider just falls back to its own local state.
 *******************************************************************************/
export interface ExpandedGridRows
{
   isProvided: boolean;
   expandedRowIds: Set<GridRowId>;
   toggleRow: (rowId: GridRowId) => void;

   /////////////////////////////////////////////////////////////////////////////////
   // every row currently in the grid (its id and its cell values by field name), //
   // and a way to expand or collapse a batch of rows at once - what a column     //
   // header's expand-all control needs to pick the rows that have something to   //
   // expand in its column                                                        //
   /////////////////////////////////////////////////////////////////////////////////
   rows: { id: GridRowId, values: any }[];
   setRowsExpanded: (rowIds: GridRowId[], expanded: boolean) => void;
}

const ExpandedGridRowsContext = createContext<ExpandedGridRows>({
   isProvided: false,
   expandedRowIds: new Set(),
   toggleRow: () =>
   {
   },
   rows: [],
   setRowsExpanded: () =>
   {
   },
});

export default ExpandedGridRowsContext;
